import './CSS/HomePage.css';
import {render} from "react-dom";
import React from 'react';
import './CSS/App.css';
import NavBarComponent from './Components/NavBarComponent.js';
import MainHeaderStatusComponent from "./Components/MainHeaderStatusComponent";
import SystemStatusListComponent from "./Components/SystemStatusListComponent";
import configureStore from "./Redux/ConfigureReduxStore";
import Provider from "react-redux/es/components/Provider";
import FooterComponent from "./Components/FooterComponent";
import HistoricalIssuesComponent from "./Components/HistoricalIssuesComponent";
import AlertComponent from "./Components/AlertComponent";
import ScrollUpComponent from "./Components/ScrollUpComponent";

//Sets up Redux
const store = configureStore();

render(
    <div>
        <Provider store={store}>
            <div className="App">
                <NavBarComponent/>
                <div className="appBody">
                    <MainHeaderStatusComponent/>
                    <AlertComponent/>
                    <SystemStatusListComponent/>
                    <HistoricalIssuesComponent/>
                    <ScrollUpComponent/>
                </div>
                <FooterComponent/>
            </div>
        </Provider>
    </div>, document.getElementById("root")
);





// WEBPACK FOOTER //
// ./src/index.js